import { AfterViewInit, Directive, ElementRef, input } from '@angular/core';
import { UserAccountFacade } from '@spartacus/user';
import { User } from '@user/const';
import { take } from 'rxjs';

@Directive({
  selector: '[sdAutofillUserData]',
  standalone: true,
})
export class AutofillUserDataDirective implements AfterViewInit {
  fieldName = input.required<string>({ alias: 'sdAutofillUserData' });

  constructor(
    private userAccountService: UserAccountFacade,
    private el: ElementRef<HTMLInputElement>,
  ) {}

  ngAfterViewInit(): void {
    this.userAccountService
      .get()
      .pipe(take(1))
      .subscribe((user: User | undefined) => {
        if (!user) {
          return;
        }

        const fieldName = this.fieldName() as keyof User;

        if (fieldName in user) {
          this.el.nativeElement.value = user[fieldName] as string;
          this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
  }
}
